import * as React from "react";
import {generatePath, Navigate, useLocation, useParams} from "react-router-dom";

type RedirectKeepingSearchProps = {
    to: string // may contain route params such as ":fastBillInvoiceId"
};

/**
 * Redirects to another path and keeps the query string, so filters kept in the URL survive.
 * Params of the current route fill the placeholders of the target.
 */
const RedirectKeepingSearch: React.FC<RedirectKeepingSearchProps> = ({to}) => {
    const {search} = useLocation();
    const params = useParams();

    return <Navigate to={generatePath(to, params) + search} replace/>;
};

export default RedirectKeepingSearch;
